export default __webpack_public_path__ + "static/media/solo-mujer-logo.355c515c.png";